import { ReactNode } from 'react';

import { CTASVGContainer } from '../Links.styled';

import { LinkContainer } from './Link.styled';

type LinksProps = {
  text: string;
  svg?: ReactNode;
  svgSize?: number;
  href?: string;
};

export const Link = ({ text, svg, svgSize, href }: LinksProps) => (
  <LinkContainer>
    <a href={href}>{text}</a> {svg && <CTASVGContainer size={svgSize}>{svg}</CTASVGContainer>}
  </LinkContainer>
);
